import { render, staticRenderFns } from "./MesLivraisons.vue?vue&type=template&id=7f3ee853"
import script from "./MesLivraisons.vue?vue&type=script&lang=js"
export * from "./MesLivraisons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports